import React from 'react';
import './PainelParalaxe1.css';

const PainelParalaxe1 = () => {
  return (
    <div className="paralaxe-container1">
      <div className="paralaxe-conteudo1">
        <div className="paralaxe-texto-container1">
          <h2 className="paralaxe-titulo1">Design de Alto Padrão, com exclusividade e personalidade</h2>
          <p className="paralaxe-texto1">
            O projeto perfeito leva a sua essência e eleva a beleza natural do seu espaço, expressando em cada detalhe sua sofisticação única. 
            Projetos que refletem seu estilo de vida e traduzem sua elegância e seu bom-gosto, em cada momento do seu dia.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PainelParalaxe1;